import {  useState } from 'react'
import { AiOutlineClose, AiOutlineMenuUnfold } from 'react-icons/ai';
import { Link } from "react-scroll";
import img from "/src/assets/img/icon.png"
export const Navbar = () => {
    const [menu, setMenu] = useState(false);

    const handleChange = () => {
        setMenu(!menu);
    };

    const closeMenu = () => {
        setMenu(false);
    };

    return (
        <div className='fixed top-0 z-10 w-full'>
            <div className='flex flex-row justify-between px-6 py-6 bg-gradient-to-r from-yellow-500 to-gray-800 shadow-[0_0px_20px_rgb(0,0,0,0.6)]'>
                <Link to='home' spy={true} smooth={true} offset={-70} duration={500}>
                    <div className='flex flex-row items-center gap-2 cursor-pointer'>
                        <span>
                            {/* <SiCoffeescript size={25} /> */}
                            <img src={img} style={{ height: "25px" }} alt="icon" />
                        </span>
                        <h1 className='text-xl font-semibold tracking-wider font-cursive2'>Kopilibrasi</h1>
                    </div>
                </Link>
                <nav className='hidden md:flex gap-4'>
                    <Link to='home' spy={true} smooth={true} offset={-70} duration={500} className='cursor-pointer text-white'>Home</Link>
                    {/* <Link to='about' spy={true} smooth={true} offset={-70} duration={500} className='cursor-pointer text-white'>About</Link> */}
                    <Link to='menu' spy={true} smooth={true} offset={-70} duration={500} className='cursor-pointer text-white'>Our Menu</Link>
                    <Link to='location' spy={true} smooth={true} offset={-70} duration={500} className='cursor-pointer text-white'>Location</Link>
                </nav>
                <div className="md:hidden flex items-center">
                    {
                        menu ?
                            (
                                <AiOutlineClose size={25} className='text-white cursor-pointer' onClick={handleChange} />
                            ) :
                            (
                                <AiOutlineMenuUnfold size={25} className='text-white cursor-pointer' onClick={handleChange} />
                            )
                    }
                </div>
            </div>
            <div className={`${menu ? "translate-x-0" : "-translate-x-full"}
            md:hidden flex flex-col absolute bg-black w-full h-fit left-0 top-16 py-6 gap-6 transition-transform duration-300 pl-6`}>
                <Link to='home' onClick={closeMenu} spy={true} smooth={true} offset={-70} duration={500} className='cursor-pointer text-white transition-all'>Home</Link>
                {/* <Link to='about' onClick={closeMenu} spy={true} smooth={true} offset={-70} duration={500} className='cursor-pointer text-white transition-all'>About</Link> */}
                <Link to='menu' onClick={closeMenu} spy={true} smooth={true} offset={-70} duration={500} className='cursor-pointer text-white transition-all'>Our Menu</Link>
                <Link to='location' onClick={closeMenu} spy={true} smooth={true} offset={-70} duration={500} className='cursor-pointer text-white transition-all'>Location</Link>
            </div>
        </div>
    )
}
